'use client'

import cx from 'classnames'
import Image, { ImageProps } from 'next/image'
import { FC } from 'react'
import { useInView } from 'react-intersection-observer'

import ULink from '@/components/Link/ULink'
import '@/components/Page/Page/Journal/JournalCard/JournalCard.scss'
import Number from '@/components/Page/Page/Journal/Number'

type ItemProps = {
  date: string
  title: string
  category: string
  titleEn: string
  href: string
  number: string
  image: ImageProps
  nextLink?: boolean
}
const JournalCard: FC<ItemProps> = ({ date, title, category, titleEn, number, href, image, nextLink = true }) => {
  const { inView, ref } = useInView({
    threshold: 0,
    rootMargin: '0px 0px -20% 0px',
    triggerOnce: true,
  })

  return (
    <div ref={ref} className={'c-page-journal-card'}>
      <ULink
        nextLink={nextLink}
        className={cx('u-mo-lineBox', {
          'c-page-journal-card--inView': inView,
        })}
        href={href}
      >
        <div className="c-page-journal-card-info">
          <div className="c-page-journal-card-top">
            <p className="c-page-journal-card-category">{category}</p>
            <span className="c-page-journal-card-border"></span>
            <p className="c-page-journal-card-date">{date}</p>
          </div>

          <div className="c-page-journal-card-heading">
            <div className="c-page-journal-card-heading--num">
              <Number number={number} />
            </div>
            <div className="c-page-journal-card-title">
              <p className="c-page-journal-card-title-ja u-font-yu-min">
                <span className="u-mo-rowsView__text u-mo-lineBox__text">{title}</span>
              </p>
              <p className="c-page-journal-card-title-en u-font-gb">{titleEn}</p>
            </div>
          </div>

          <div className="c-page-journal-card-container">
            <Image src={image.src} width={image.width} height={image.height} alt={'-'} />
          </div>
        </div>
      </ULink>
    </div>
  )
}

export default JournalCard
